import Script from "next/script";
import { useChat } from "@/hooks/chat/useChat";
import ProactiveChatModal from "@/blocks/Modals/ProactiveChatModal";

import { KORE_CHAT_SDK_BASE_URL, CHAT_TYPES } from "@/js/constants/chat";

const Chat = () => {
  const { sdkVersion, chatType, resizeChatButton } = useChat();

  if (chatType === CHAT_TYPES.NONE) return null;

  return (
    <>
      <link
        rel={"stylesheet"}
        href={`${KORE_CHAT_SDK_BASE_URL}/${sdkVersion}/kore-chatbot-v2-fuel.min.css`}
      />
      {chatType === CHAT_TYPES.PROACTIVE_V2 && <ProactiveChatModal />}
      <Script
        strategy="lazyOnload"
        src={`${KORE_CHAT_SDK_BASE_URL}/${sdkVersion}/kore-chatbot-v2-fuel.min.js`}
        onLoad={resizeChatButton}
      />
    </>
  );
};

Chat.displayName = "Chat";

export default Chat;
